const mEditionProductPagesOfGratefulnessModalUndefined = {
  mEditionProductPagesOfGratefulnessModalUndefined: {
    buttonPrimary: 'Entendido',

    messageUndefined: {
      first: 'La página de agradecimiento que estás intentando ver aún no existe ya que nunca ha sido publicada.',
      second: 'Si ya publicaste esta página, por favor espera unos minutos hasta que la misma sea procesada y vuelve a intentarlo.'
    },

    title: 'Acción Deshabilitada'
  }
}

export default mEditionProductPagesOfGratefulnessModalUndefined
